module.exports = __webpack_public_path__ + "static/media/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver-norming.60450c64.mp3";